import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Logout } from '@core/services/core/auth/auth.actions';
import { AuthService } from '@core/services/core/auth/auth.service';
import { ContextService } from '@core/services/core/context.service';
import { mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LogoutGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private ctx: ContextService,
    private router: Router
  ) {}

  canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot) {
    const redirectToUrl = this.getRedirectUrl();
    return this.auth.dispatch$(new Logout({ softLogout: true })).pipe(mapTo(this.router.parseUrl(redirectToUrl)));
  }

  private getRedirectUrl() {
    const isLoggedIn = this.auth.getState().isLogged;
    if (isLoggedIn) {
      return this.ctx.isAccessTypeParticular ? '/login/particulares' : '/login/empresas';
    }
    return '/login';
  }
}
